import { NavLink, Outlet } from 'react-router-dom'
import ModelGate from './ModelGate'
import { publicMode } from '../lib/runtime'

const ALL_NAV = [
  { to: '/text', label: 'Text chat', end: false, admin: false },
  { to: '/voice', label: 'Voice chat', end: false, admin: false },
  { to: '/console', label: 'Console', end: false, admin: false },
  { to: '/trainer', label: 'Trainer', end: false, admin: false },
  { to: '/agents', label: 'Agents', end: false, admin: true },
  { to: '/settings', label: 'Settings', end: false, admin: true },
] as const

export default function AppShell() {
  const NAV = ALL_NAV.filter((item) => !publicMode || !item.admin)
  return (
    <div className="panel-shell">
      <aside className="panel-sidebar" aria-label="Navigation">
        <div className="panel-sidebar-head">
          <NavLink to="/text" className="panel-brand" end>
            <span className="panel-brand-title">LiveKit-Local</span>
          </NavLink>
          <span className="panel-kicker">Control</span>
        </div>

        <nav className="panel-nav" aria-label="Pages" data-testid="sidebar-nav">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                isActive ? 'panel-nav-item active' : 'panel-nav-item'
              }
              data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </aside>

      <div className="panel-main">
        <ModelGate>
          <Outlet />
        </ModelGate>
      </div>
    </div>
  )
}
